import i18n from '@/i18n'
import { pickBy } from '@/utils'
import AttrGoods from './attr-goods'
import CompPickerLink from '../../comps/comp-pickerLink'

export default {
  name: 'goodsGrid',
  setting: [
    { label: i18n.t('wgt_goodsGrid.config.739698-0'), key: 'title', component: 'input', value: i18n.t('wgt_goodsGrid.config.739698-1') },
    { label: i18n.t('wgt_goodsGrid.config.739698-2'), key: 'subtitle', component: 'input', value: i18n.t('wgt_goodsGrid.config.739698-3') },
    { label: i18n.t('wgt_goodsGrid.config.739698-4'), key: 'padded', component: 'switch', value: true },
    {
      label: i18n.t('wgt_goodsGrid.config.739698-5'),
      key: 'style',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_goodsGrid.config.739698-6'), label: 'grid' },
        { name: i18n.t('wgt_goodsGrid.config.739698-7'), label: 'grids' }
      ],
      value: 'grid'
    },
    { label: i18n.t('wgt_goodsGrid.config.739698-8'), key: 'showPrice', component: 'switch', value: false },
    { label: i18n.t('wgt_goodsGrid.config.739698-9'), key: 'brand', component: 'switch', value: true },
    {
      label: i18n.t('wgt_goodsGrid.config.739698-10'),
      key: 'data',
      component: function (h, { key }) {
        return <AttrGoods v-model={this.value[key]} />
      },
      value: [
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: i18n.t('wgt_goodsGrid.config.739698-11'),
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: i18n.t('wgt_goodsGrid.config.739698-11'),
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: i18n.t('wgt_goodsGrid.config.739698-11'),
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: i18n.t('wgt_goodsGrid.config.739698-11'),
          id: '',
          price: 0,
          market_price: 0
        }
      ]
    },
    {
      label: i18n.t('wgt_goodsGrid.config.739698-12'),
      key: 'moreLink',
      component: function (h, { key }) {
        return <CompPickerLink v-model={this.value[key]} style='margin-top: 7px;' />
      }
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data, list, distributor_id } = v
    return {
      name,
      ...base,
      ...config,
      data,
      list,
      distributor_id
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          brand: 'brand',
          showPrice: 'showPrice',
          style: 'style',
          moreLink: 'moreLink'
        })
      },
      data: 'data'
    })
  }
}
